var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { privateHttp } from '../helpers/Http';
import { generateUrl } from '../helpers/Utils';
export var NOTIFICATIONS_TYPES = {
    NEW_PROCESS: 'NEW_PROCESS',
    CHANGE_MOVIMENT: 'CHANGE_MOVIMENT',
};
var urlBase = process.env.REACT_APP_API_BASE_URL;
export var ITEMS_PER_PAGE = 10;
var getAll = function (organizationId, params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var url, _a, result, total;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = generateUrl(urlBase, "/v1/organization/".concat(organizationId, "/notifications"), params);
                    return [4 /*yield*/, privateHttp.get(url)];
                case 1:
                    _a = _b.sent(), result = _a.result, total = _a.total;
                    return [2 /*return*/, {
                            items: result.map(function (item) {
                                var _a, _b, _c, _d, _e;
                                return ({
                                    id: item.userNotifyHistory.userNotifyHistoryId,
                                    type: item.userNotifyHistory.notifyType,
                                    processId: item.userNotifyHistory.processId,
                                    processNumber: item.userNotifyHistory.number,
                                    court: item.userNotifyHistory.tribunalOrigin.court,
                                    date: item.userNotifyHistory.updatedAt,
                                    authors: (_a = item.userNotifyHistory.docs) === null || _a === void 0 ? void 0 : _a.authors,
                                    defendants: (_b = item.userNotifyHistory.docs) === null || _b === void 0 ? void 0 : _b.defendants,
                                    lastUpdate: {
                                        class: (_c = item.userNotifyHistory.docs) === null || _c === void 0 ? void 0 : _c.last_class_message,
                                        date: (_d = item.userNotifyHistory.docs) === null || _d === void 0 ? void 0 : _d.last_update,
                                        text: (_e = item.userNotifyHistory.docs) === null || _e === void 0 ? void 0 : _e.last_update_message,
                                    },
                                    wasViewed: ![undefined, null].includes(item.userNotifyHistory.visualizedAt),
                                });
                            }),
                            total: total,
                            limit: ITEMS_PER_PAGE,
                        }];
            }
        });
    });
};
var getTotal = function (organizationId) {
    var url = generateUrl(urlBase, "/v1/organization/".concat(organizationId, "/notifications/total"));
    return privateHttp.get(url);
};
var updateItem = function (organizationId, id) {
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/notifications/").concat(id);
    return privateHttp.put(url);
};
var clearAll = function (organizationId) {
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/notifications");
    return privateHttp.delete(url);
};
export var NotificationService = {
    getAll: getAll,
    getTotal: getTotal,
    updateItem: updateItem,
    clearAll: clearAll,
};
